import { parseAsStringEnum, useQueryState } from "nuqs";
import { DataVisualizationType } from "components/charting/config/chartTypes";

function useDataVisualisationQueryState() {
  return useQueryState(
    "visType",
    parseAsStringEnum<DataVisualizationType>(Object.values(DataVisualizationType)).withDefault(
      DataVisualizationType.LINE_CHART
    )
  );
}

export default useDataVisualisationQueryState;
